import { cn } from '../../lib/cn';

/**
 * Заглушка вместо спиннера: экран сразу показывает будущую форму содержимого,
 * поэтому переход к данным не выглядит прыжком.
 */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('bg-surface-2 animate-shimmer rounded-lg', className)} />;
}

export function OrderCardSkeleton() {
  return (
    <div className="bg-surface-3 border-line rounded-card space-y-3 border p-4">
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-5 w-20 rounded-full" />
      </div>
      <Skeleton className="h-4 w-40" />
      <div className="flex items-center justify-between">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-5 w-16" />
      </div>
    </div>
  );
}

export function ListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }, (_, index) => (
        <OrderCardSkeleton key={index} />
      ))}
    </div>
  );
}
